import { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Chip,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import ListScreen from "../../../main/components/ListScreen";
import { TableRowType } from "../../../main/components/RopTable/RopTable";
// import { mockClients } from "../mock/fakeClientApi";
import { Client, Collaborator, NewCollaboratorForm } from "../types";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";
import { AddItemModals } from "../../users/components/AddItemModals";
import { AddCollaboratorFormModal } from "./AddCollaboratorFormModal";
import CollaboratorDetailsModal from "./CollaboratorDetailsModal";
import { RemoveCollaboratorsModals } from "./RemoveCollaboratorsModals";
import { User, UserRoles } from "../../users/types";
import { useNavigate, useParams } from "react-router-dom";
import { clientsApi, usinasApi, usersApi } from "../../../services/api";
import { Item } from "../../users/components/UserItemsTable";
import { Usina } from "../../usinas/types";
import CloseIcon from "@mui/icons-material/Close";
import BaseButton from "../../../main/components/BaseButton";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import { MainContext } from "../../../main/context/MainContextProvider";

export default function ClientDetailsTableCollaborators() {
  const { id } = useParams<{ id: string }>();
  const { user } = useContext(MainContext);
  const [client, setClient] = useState<Client | null>(null);

  const [searchTerm, setSearchTerm] = useState<string>("");
  const [usinas, setUsinas] = useState<Usina[]>([]);
  const [selectedCollaborator, setSelectedCollaborator] = useState<Item | null>(
    null
  );
  const navigate = useNavigate();

  const [showCollaboratorsDetialsModal, setShowCollaboratorsDetialsModal] =
    useState<boolean>(false);
  const [showAddCollaboratorModal, setShowAddCollaboratorModal] =
    useState<boolean>(false);

  const [showRemoveCollaboratorModal, setShowRemoveCollaboratorModal] =
    useState<boolean>(false);
  const [users, setUsers] = useState<User[]>([]);
  const [openEditConfirmationAddWppModal, setOpenEditConfirmationAddWppModal] =
    useState(false);

  const [collaboratorDetails] = useState<Collaborator>();

  const [showCreateNewCollaboratorModal, setShowCreateNewCollaboratorModal] =
    useState<boolean>(false);
  const [openErrorAddWhatsAppModal, setOpenErrorAddWhatsAppModal] =
    useState(false);
  const [openErrorRemoveWhatsAppModal, setOpenErrorRemoveWhatsAppModal] =
    useState(false);
  const [openSuccessAddWhatsAppModal, setOpenSuccessAddWhatsAppModal] =
    useState(false);
  const [openSuccessRemoveWhatsAppModal, setOpenSuccessRemoveWhatsAppModal] =
    useState(false);

  const onMount = async (clientId: string) => {
    try {
      const clientResponse = await clientsApi.getClient(clientId);
      const usinasResponse = await usinasApi.getUsinas();
      if (user?.hasAllAccess) {
        const userResponse = await usersApi.getUsers();

        const collaboratorsEmails = clientResponse.collaboratorsList?.map(
          (collaborator: Collaborator) => collaborator.email
        );
        const filteredUsers = userResponse.data.filter((user) => {
          return !collaboratorsEmails?.includes(user.email);
        });

        setUsers(filteredUsers);
      }
      setClient(clientResponse);
      setUsinas(usinasResponse.data);
    } catch (error) {
      throw new Error("Erro ao carregar cliente");
    }
  };
  useEffect(() => {
    if (id) {
      onMount(id);
    } else {
      console.log("ID da rota não encontrado");
    }
  }, [id]);

  const AddCollaborator = async () => {
    user?.hasAllAccess
      ? setShowAddCollaboratorModal(true)
      : setShowCreateNewCollaboratorModal(true);
  };

  const onRemoveCollaborator = async (item: Item) => {
    setSelectedCollaborator(item);
    setShowRemoveCollaboratorModal(true);
  };

  const onAddCollaboratorWhatsApp = async (item: Item) => {
    setSelectedCollaborator(item);
    setOpenEditConfirmationAddWppModal(true);
  };

  const onRemoveCollaboratorWhatsApp = async (item: Item) => {
    setSelectedCollaborator(item);
    setOpenEditConfirmationRemoveWppModal(true);
  };
  const [
    openEditConfirmationRemoveWppModal,
    setOpenEditConfirmationRemoveWppModal,
  ] = useState(false);

  const onConfirmRemoveCollaborator = async () => {
    if (!selectedCollaborator || !client) return;
    await clientsApi.removeCollaborator(
      client.id,
      selectedCollaborator.email ?? ""
    );
  };

  const onConfirmAddCollaborator = async (item: Item) => {
    // if (!client) return;
    const selectedUser = users.find((user) => user.email === item.email);
    const collaborator: NewCollaboratorForm = {
      email: selectedUser?.email || "",
      name: selectedUser?.name || "",
      cpf: selectedUser?.cpf || "",
      phone: selectedUser?.phone || "",
      usinasIds: [],
      roles: [UserRoles.User],
    };
    if (client) {
      // await clientsApi.AddCollaborator(clients[0].id, collaborator);
      await clientsApi.AddCollaborator(client.id, collaborator);
    }
  };

  const onConfirmAddWhatsApp = async () => {
    setOpenEditConfirmationAddWppModal(false);
    if (client) {
      await clientsApi.pathAddColaboratorWhatsApp(
        client.id,
        selectedCollaborator?.email ?? ""
      );
    }
  };

  const onConfirmRemoveWhatsApp = async () => {
    setOpenEditConfirmationRemoveWppModal(false);
    if (client) {
      await clientsApi.pathRemoveColaboratorWhatsApp(
        client.id,
        selectedCollaborator?.email ?? ""
      );
    }
  };

  const searchFilter = (item: any, term: string) => {
    const lowerCaseTerm = term.toLowerCase();

    const result = Object.values(item).some((value) => {
      if (typeof value === "string") {
        const match = value.toLowerCase().includes(lowerCaseTerm);

        return match;
      } else if (Array.isArray(value)) {
        const match = value.some((val) =>
          val.toString().toLowerCase().includes(lowerCaseTerm)
        );

        return match;
      } else {
        return false;
      }
    });

    return result;
  };

  const filteredClients = client?.collaboratorsList?.filter((collaborator) =>
    searchFilter(collaborator, searchTerm)
  );

  // const filteredClients = clients[0]?.collaboratorsList?.filter(
  //   (collaborator) => searchFilter(collaborator, searchTerm)
  // );

  const maxLenth = 3;
  // const minWhatsAppAmount = clients[0].collaboratorsList?.filter(
  //   (item) => item.whatsappEnabled === true
  // ).length;
  const handleUpdate = () => {
    if (client?.id) {
      onMount(client.id);
    }
  };

  const tableRows: TableRowType[] =
    filteredClients?.map((e) => {
      return {
        // onClick: () => {
        //   setCollaboratorDetails(e);
        //   setShowCollaboratorsDetialsModal(true);
        // },
        rowItems: [
          {
            item: e.name || "",
            isMobile: true,
          },
          {
            item: (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {e.usinasIds?.map((usinaId) => {
                  const usina = usinas.find((u) => u.usinaIds.id === usinaId);
                  return usina ? (
                    <Chip
                      key={usina.usinaIds.id}
                      size="small"
                      sx={{
                        marginRight: "5px",
                        fontSize: "11px",
                        height: "18px",
                        width: "fit-content",
                      }}
                      label={usina.name}
                      variant="outlined"
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        navigate(`/usinas/${usina.usinaIds.id}`);
                      }}
                    />
                  ) : null;
                })}
              </Box>
            ),
            // align: "center",
            isMobile: true,
          },
          {
            item: e.roles ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {e.roles?.slice(0, maxLenth).map((role) => (
                  <Chip
                    key={role}
                    sx={{
                      marginRight: "5px",
                      fontSize: "11px",
                      height: "18px",
                      width: "fit-content",
                    }}
                    size="small"
                    label={role}
                    variant="outlined"
                  />
                ))}
                {e.roles?.length > maxLenth && (
                  <Chip
                    sx={{
                      marginRight: "5px",
                      fontSize: "11px",
                      height: "18px",
                      width: "fit-content",
                    }}
                    size="small"
                    label={"..."}
                    variant="outlined"
                  />
                )}
              </Box>
            ) : (
              ""
            ),
            // align: "center",
            isMobile: true,
          },
          {
            item: e.whatsappEnabled ? (
              <Tooltip title="Desativar WhatsApp">
                <IconButton
                  sx={{ cursor: "pointer" }}
                  onClick={(event) => {
                    event.stopPropagation();
                    onRemoveCollaboratorWhatsApp(e);
                  }}
                >
                  <WhatsAppIcon sx={{ color: "green" }} />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Ativar WhatsApp">
                <IconButton
                  sx={{ cursor: "pointer", color: "gray" }}
                  onClick={(event) => {
                    event.stopPropagation();
                    onAddCollaboratorWhatsApp(e);
                  }}
                >
                  <WhatsAppIcon />
                </IconButton>
              </Tooltip>
            ),
            align: "center",
            isMobile: true,
          },
          {
            item: (
              <Tooltip title={`Remover ${e.name}`}>
                <IconButton
                  sx={{
                    width: {
                      xs: "25px",
                    },
                    height: {
                      xs: "25px",
                    },
                    marginLeft: {
                      xs: "auto",
                      sm: "10px",
                    },
                  }}
                  onClick={(event) => {
                    event.stopPropagation();
                    onRemoveCollaborator(e);
                  }}
                >
                  <CloseIcon color="error" />
                </IconButton>
              </Tooltip>
            ),
            align: "center",
            isMobile: true,
          },
        ],
      };
    }) || [];

  return (
    <>
      <Stack
        flexDirection="row"
        justifyContent="space-between"
        marginTop="30px"
      >
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: { xs: "14px", md: "17px" },
            marginTop: { xs: "-5px", md: "5px" },
            // marginTop: "5px",
            height: "34px",
          }}
        >
          Colaboradores
        </Typography>
        <BaseButton
          width={120}
          startIcon={<AddIcon />}
          title="Adicionar"
          onClick={() => AddCollaborator()}
          heigth={34}
          iconSize={"15px"}
          fontSize={"15px"}
        />
      </Stack>
      <TextField
        placeholder="Pesquisar Colaborador"
        variant="standard"
        fullWidth
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ width: "20px", height: "20px" }} />
            </InputAdornment>
          ),
        }}
      />
      <ListScreen
        hover
        isLoading={false}
        marginTopTable="0px"
        maxHeigth="45vh"
        bodyHeighTable="-70vh"
        itemsHeaders={[
          {
            item: "Nome",
            isMobile: true,
          },
          {
            item: "Usina(s)",
            isMobile: true,
          },
          {
            item: "Roles",
            isMobile: true,
          },
          {
            item: "Whatsapp Enabled",
            align: "center",
          },
          {
            item: "Excluir Colaborador",
            align: "center",
          },
        ]}
        itemRows={tableRows}
      />

      <CollaboratorDetailsModal
        item={collaboratorDetails ?? {}}
        setShowDetailsModal={setShowCollaboratorsDetialsModal}
        showDetailsModal={showCollaboratorsDetialsModal}
        clientId={client?.id ?? ""}
        // clientId={clients[0].id}
        update={handleUpdate}
      />
      <RemoveCollaboratorsModals
        onConfirmRemoveCollaborator={onConfirmRemoveCollaborator}
        showRemoveCollaboratorModal={showRemoveCollaboratorModal}
        setShowRemoveCollaboratorModal={setShowRemoveCollaboratorModal}
        collaboratorName={selectedCollaborator?.name || ""}
        onMount={handleUpdate}
      />
      <AddItemModals
        itemName="Colaboradores"
        itemText="o colaborador"
        items={users}
        onConfirmAddItem={onConfirmAddCollaborator}
        setShowAddItemModal={setShowAddCollaboratorModal}
        showAddItemModal={showAddCollaboratorModal}
        onMount={handleUpdate}
        extraButton={
          <Button
            type="button"
            variant="contained"
            onClick={() => {
              setShowAddCollaboratorModal(false);
              setShowCreateNewCollaboratorModal(true);
            }}
          >
            Cadastrar Novo
          </Button>
        }
      />
      <AddCollaboratorFormModal
        clientId={client?.id ?? ""}
        // clientId={mockClients[0].clientFounded.id}
        itemName="Colaborador"
        itemText="o colaborador"
        setShowAddFormModal={setShowCreateNewCollaboratorModal}
        showAddFormModal={showCreateNewCollaboratorModal}
        onMount={handleUpdate}
      />
      <ConfirmationModal
        open={openEditConfirmationRemoveWppModal}
        setOpen={setOpenEditConfirmationRemoveWppModal}
        title="Remover WhatsApp"
        contentText="deseja mesmo Remover um whatsApp?"
        onConfirm={onConfirmRemoveWhatsApp}
        setOpenErrorModal={setOpenErrorRemoveWhatsAppModal}
        setOpenSuccessModal={setOpenSuccessRemoveWhatsAppModal}
      />
      <ActionAlert
        message="O whatsApp foi removido com sucesso"
        severity="success"
        open={openSuccessRemoveWhatsAppModal}
        setOpen={setOpenSuccessRemoveWhatsAppModal}
        onClose={() => {
          setOpenEditConfirmationRemoveWppModal(false);
          handleUpdate();
        }}
      />
      <ActionAlert
        message="Ocorreu um erro ao remover whatsApp"
        severity="error"
        open={openErrorRemoveWhatsAppModal}
        setOpen={setOpenErrorRemoveWhatsAppModal}
        onClose={() => {
          setOpenErrorRemoveWhatsAppModal(false);
        }}
      />

      {/* fluxo de adiÃ§Ã£o de whatsApp do colaborador */}
      <ConfirmationModal
        open={openEditConfirmationAddWppModal}
        setOpen={setOpenEditConfirmationAddWppModal}
        title="Adicionar WhatsApp"
        contentText="deseja mesmo Adicionar um novo whatsApp?"
        onConfirm={onConfirmAddWhatsApp}
        setOpenErrorModal={setOpenErrorAddWhatsAppModal}
        setOpenSuccessModal={setOpenSuccessAddWhatsAppModal}
      />
      <ActionAlert
        message="O whatsApp foi adicionado com sucesso"
        severity="success"
        open={openSuccessAddWhatsAppModal}
        setOpen={setOpenSuccessAddWhatsAppModal}
        onClose={() => {
          setOpenEditConfirmationAddWppModal(false);
          //   onMount();
        }}
      />
      <ActionAlert
        message="Ocorreu um erro ao adicionar whatsApp"
        severity="error"
        open={openErrorAddWhatsAppModal}
        setOpen={setOpenErrorAddWhatsAppModal}
        onClose={() => {
          setOpenErrorAddWhatsAppModal(false);
        }}
      />
    </>
  );
}
